// Home carousel slides. Plain CommonJS so scripts/prerender.js can emit <link rel="preload">
// for the first slide in the prerendered HTML (before React boots).
const site = require("../seo/site");

const SLIDES = [
  {
    id: "img/home/slider/slider-01",
    alt: "Guests exploring a lantern-lit underground cellar on the Queen City Underground tour",
    header: "Underground Tours",
    caption: "Join us below the city to explore Cincinnati's hidden past.",
    links: [
      { to: "/ultimate-underground", label: "Ultimate Queen City Underground" },
      { to: "/hiddencaverns", label: "Hidden Caverns Tour" },
    ],
  },
  {
    id: "img/home/slider/slider-02",
    alt: "Vintage baseball scene from the 1919 World Series era in downtown Cincinnati",
    header: "1919: The Year That Changed Baseball",
    caption: "Join us to learn about 1919, the year that truly changed baseball forever.",
    links: [{ to: "/1919-tour", label: "Explore This Tour" }],
  },
  {
    id: "img/home/slider/slider-03",
    alt: "Historic Monmouth Street in Newport, Kentucky, once home to mob-run casinos",
    header: "Newport Gangster Tour",
    caption: "Walk the streets where the mob made millions, gamblers lost everything, and legends were born.",
    links: [{ to: "/newport-gangster-tour", label: "Explore This Tour" }],
  },
  {
    id: "img/home/slider/slider-04",
    alt: "A dimly lit historic street at night on a haunted walking tour",
    header: "Haunted Tours",
    caption: "Discover grisly murders, ghastly deaths, and disturbing tales buried within the Tri-State's storied past.",
    links: [
      { to: "/mt-healthy-is-haunted", label: "Mt. Healthy is Haunted" },
      { href: "#tours", label: "See All Tours" },
    ],
  },
];

function slideDesktopUrl(id) {
  return site.CLOUDINARY + "/c_fill,w_1800,h_700/f_auto,q_auto/" + id;
}

function slideMobileUrl(id) {
  return site.CLOUDINARY + "/c_fill,w_800,h_800/f_auto,q_auto/" + id;
}

module.exports = { SLIDES: SLIDES, slideDesktopUrl: slideDesktopUrl, slideMobileUrl: slideMobileUrl };
